import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ISlideshow } from '../../pages/slideshows/slideshows.interface';
import { HttpUtilitiesService, IBaseResponse } from '../../utilities/http-utilities.service';
import { slideshowContentActions } from './slideshow-content.actions';
import { SlideshowContentService } from './slideshow-content.service';

@Injectable()
export class SlideshowContentEffects {
  fetchSlideshowContents$ = createEffect(() =>
    this.actions$.pipe(
      ofType(slideshowContentActions.fetchSlideshowContents.type),
      switchMap(({ slideshowId }: ReturnType<typeof slideshowContentActions.fetchSlideshowContents>) => {
        const httpParams = this.httpUtilities.insertGenericCrudRequestParameters({});

        return this.service.getSlideshowContent(slideshowId, { params: httpParams }).pipe(
          switchMap((response: IBaseResponse<ISlideshow>) => {
            return of(
              slideshowContentActions.fetchSlideshowContentsCompleted({
                slideshow: { ...response.data },
              }),
            );
          }),
          catchError(() => of(slideshowContentActions.fetchError({ exceptionSource: 'fetchSlideshowContents' }))),
        );
      }),
    ),
  );

  constructor(
    private readonly actions$: Actions,
    private readonly service: SlideshowContentService,
    private readonly httpUtilities: HttpUtilitiesService,
  ) {}
}
